export enum ToastVariant {
	Success = "success",
	Error = "error",
	Warning = "warning",
	Info = "info",
}

export type AzmToastType = "toast-success" | "toast-error" | "toast-warning" | "toast-info";

export interface ToastIconPreset {
	icon: string;
	iconClass: string;
}

export interface AzmToastConfig {
	timeOut?: number;
	extendedTimeOut?: number;
	progressBar?: boolean;
	closeButton?: boolean;
	tapToDismiss?: boolean;
	easeTime?: number;
}

export const AZM_TOAST_DEFAULT_CONFIG: Required<AzmToastConfig> = {
	timeOut: 5000,
	extendedTimeOut: 2000,

	progressBar: true,
	closeButton: true,
	tapToDismiss: true,
	easeTime: 300,
};

export interface AzmToastRef {
	toastId: number;
	close: () => void;
}
